import { Layers } from "appworks/graphics/layers/layers";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { AutoStopControl } from "appworks/ui/controls/standard/button/auto-stop-control";
import { ControlFactory } from "../control-factory";

export class AutoStopControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        if (layer.getFlexiButton("autoplay_stop_button")) {
            return true;
        }
        return false;
    }

    public build(layer: Layers): AbstractControl[] {
        return [ new AutoStopControl(layer.getFlexiButton("autoplay_stop_button")) ];
    }
}
